import { normalizeBrandTheme, type BrandTheme } from './brandTheme';
import platformDefault from './fixtures/platform-default.v1.json';

/** The built-in theme (CNPWKS-0007 C2): saas-auth's platform-default document, vendored verbatim. */
function builtIn(): BrandTheme {
  const theme = normalizeBrandTheme(platformDefault);
  if (!theme)
    throw new Error('src/theme/fixtures/platform-default.v1.json is not a valid v1 brand theme');
  return theme;
}
export const PLATFORM_DEFAULT_THEME: BrandTheme = builtIn();
